var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPaused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4146_249210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11L1.5 11C1.36739 11 1.24021 10.9473 1.14645 10.8536C1.05268 10.7598 1 10.6326 1 10.5L1 8L4.76995e-08 8L1.78873e-08 10.5C1.31433e-08 10.8978 0.158035 11.2794 0.43934 11.5607C0.720644 11.842 1.10218 12 1.5 12L10.5 12C10.8978 12 11.2794 11.842 11.5607 11.5607C11.842 11.2794 12 10.8978 12 10.5L12 8L11 8L11 10.5C11 10.6326 10.9473 10.7598 10.8536 10.8536C10.7598 10.9473 10.6326 11 10.5 11Z",
    fill: "#E44258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93924 0.438661L2.64624 2.73166L3.35324 3.43866L5.48524 1.30666L5.49974 9.50016L6.49974 9.50016L6.48524 1.27866L8.64624 3.43966L9.35324 2.73266L7.06024 0.43966C6.77908 0.15832 6.39769 0.000168845 5.99995 -1.90335e-05C5.6022 -0.000206912 5.22066 0.157587 4.93924 0.438661Z",
    fill: "#E44258"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4146_249210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 12) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPaused);
export default __webpack_public_path__ + "static/media/upload-paused.9b9e8d07fffe5c2bbdf7bba0a33ae905.svg";
export { ForwardRef as ReactComponent };